import template from './cardDetails.html';
import controller from './cardDetails.controller';
import './cardDetails.scss';

let cardDetailComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    headerLinkTitle: '@?',
    headerClass: '@?'
  },
  template,
  controller
};

export default cardDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/cardDetails/cardDetails.component.js